import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/css/index.css";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App style={{ minHeight: "100%" }} />
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
